import React from 'react';
import './Pricing.css';

const Pricing = () => {
  return (
    <div className="pricing-container">
      <p className="pricing-title">Pricing</p>
      <div className="pricing-options">
        <div className="pricing-box free">
          <h3>Free</h3>
          <p className="price">$0/month</p>
          <ul>
            <li>500 characters</li>
            <li>5 uses per month</li>
          </ul>
          <button className="pricing-button">Choose Free</button>
        </div>
        <div className="pricing-box pro">
          <h3>Pro</h3>
          <p className="price">$10/month</p>
          <ul>
            <li>2,000 characters</li>
            <li>20 uses per month</li>
          </ul>
          <button className="pricing-button">Choose Pro</button>
        </div>
        <div className="pricing-box premium">
          <h3>Premium</h3>
          <p className="price">$20/month</p>
          <ul>
            <li>5,000 characters</li>
            <li>Unlimited uses</li>
          </ul>
          <button className="pricing-button">Choose Premium</button>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
